export default function SegmentedControl({
  options,
  value,
  onChange,
  ariaLabel,
  className = "",
  size = "medium",
  disabled = false,
}) {
  const sizeClassName = size === "compact" || size === "sm"
    ? " ds-segmented--compact"
    : size === "medium" || size === "md"
      ? " ds-segmented--medium"
      : "";

  return (
    <div className={`ds-segmented${sizeClassName}${className ? ` ${className}` : ""}`} role="tablist" aria-label={ariaLabel}>
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={selected}
            className={`ds-segmented__button${selected ? " is-active" : ""}`}
            onClick={() => onChange(option.value)}
            disabled={disabled || option.disabled}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
